"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureAuthoriser = void 0;
const features_1 = require("../features");
const configureAuthoriser = (asyncConnectionMode) => {
    return new features_1.MbAuthoriser(asyncConnectionMode);
};
exports.configureAuthoriser = configureAuthoriser;
//# sourceMappingURL=authoriser.js.map